// Local definition of AttachState to avoid dependency on @fluidframework/container-definitions
export enum AttachState {
    Detached = "Detached",
    Attaching = "Attaching",
    Attached = "Attached",
}

